import React from 'react';
import { Grid, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, CircularProgress } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  dialog: {
    fontFamily: 'TIM Sans',
    padding: 40,

    minWidth: '50%',
    minHeight: '25%'
  },
  dialogTitle: {
    padding: 'unset'
  },
  dialogTitleText: {
    font: "Bold 20px/27px TIM Sans"
  },
  dialogContent: {
    padding: 'unset',
    width: "60%"
  },
  dialogContentText: {
    font: 'Regular 14px/19px TIM Sans',
    color: '#000',
  },
  cancelButton: {
    font: 'Bold 14px/19px TIM Sans',
    textTransform: 'none',
    color: "#383838",
    marginRight: "40px"
  },
  successButton: {
    borderRadius: 26,
    font: 'Bold 14px/19px TIM Sans',
    textTransform: 'none',
    height: "40px",
    width: "123px",
    background: '#03B8FF 0% 0% no-repeat padding-box',
    color: '#FFF',
    '&:hover': {
      background: '#03B8FF 0% 0% no-repeat padding-box',
    }
  },
  cancelSheet: {
    background: '#9CA1A9 0% 0% no-repeat padding-box',
    borderRadius: '26px',
    marginRight: '25px',
    padding: '10px',
    font: 'Bold 14px/19px TIM Sans',
    textTransform: 'none',
    color: '#FFFFFF',
    '&:hover': {
      background: '#9CA1A9 0% 0% no-repeat padding-box',
    }
  },
  blackButton: {
    font: '14px/19px TIM Sans',
    textTransform: 'none',
    color: '#FFFFFF',
    '&:hover': {
      color: '#FFFFFF'
    },
    marginRight: 6
  },
  button: {
    font: 'Bold 14px/19px TIM Sans',
    width: '147px',
    height: '40px',
    textTransform: 'none',
    color: '#fff'
  },
  grow: {
    flexGrow: 1
  }
}));

export default function ImportDialog(props) {
  const classes = useStyles();

  const handleClose = () => {
    if (props.handleCloseFunction) {
      props.handleCloseFunction();
    }
    props.closeDialog();
  };

  return (
    <div>
      <Button className={classes.blackButton} onClick={() => props.openDialog()}>
        {props.buttonLabel}{props.iconComponent}
      </Button>
      <Dialog open={props.isOpened} classes={{ paper: classes.dialog }} onClose={handleClose}>
        <DialogTitle className={classes.dialogTitle}>
          <Grid container alignItems="center" direction="row">
            <Grid item className={classes.dialogTitleText}>{props.title}</Grid>
            <Grid item className={classes.grow}></Grid>
            <Grid item>
              <IconButton aria-label="close" className={classes.closeIcon} onClick={handleClose}>
                <CancelIcon style={{ color: "#D7D9DD" }} />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent classes={{ root: classes.dialogContent }}>
          <DialogContentText component="div" className={classes.dialogContentText}>
            {props.children}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} className={classes.cancelButton}>
            {props.cancelLabel}
          </Button>
          <Button onClick={() => { props.successFunction(); }} style={props.disableSend ? { color: "#fff", opacity: "50%" } : null} disabled={props.disableSend ? props.disableSend : props.isImported ? true : null} className={classes.successButton} autoFocus>
            {props.isImported ? <CircularProgress style={{ color: '#FFF', width: 20, height: 20 }} /> : props.successLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}